import * as h2Api from '../h2Api'
import * as clusterReportActions from '../actions/clusterReport'
import * as adminUserActions from '../actions/admin/adminUserActions'

const initialSavedConfirm = {
  visible: false,
  forUser: null
}
const initialState = {
  summary: {},
  flaggedItems: {},
  showSavedConfirm: initialSavedConfirm
}
const clusterReport = (state = initialState, action) => {
  switch (action.type) {
    case clusterReportActions.REPORT_DATA_SAVE_PORTFOLIO:
      return {
        ...state,
        showSavedConfirm: {
          visible: true,
          forUser: action.user ? action.user.name : null
        }
      }

    case adminUserActions.CLEAR_PROFILE:
      return {
        ...state,
        showSavedConfirm: initialSavedConfirm
      }

    case clusterReportActions.REPORT_DATA_SAVE_PORTFOLIO_DISMISS:
      return {
        ...state,
        showSavedConfirm: {
          visible: false
        }
      }

    case clusterReportActions.REPORT_DATA_LOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          summary: action.restCall.result
        }
      }

      return state

    default:
      return state
  }
}

export default clusterReport
